import { ViewEncapsulation, ElementRef, Injector, Component, OnInit, Input, HostListener } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { AddressesService } from '../../../Services/addresses/Addresses';
import { forEach } from 'lodash';
import { Element } from '@angular/compiler';
import { LoadTimeService } from '../../../Services/LoadTimeService/load-time-service';

@Component({
	selector: 'map',
	encapsulation: ViewEncapsulation.None,
	template: `
		<div class="map-wrapper">
			<div [hidden]="!notAbleToLocate" class="unable-to-locate">Address could not be located</div>
			<span *ngIf="mapVisible && showMap">
				<ngui-map center="{{ coordinates.center }}">
					<marker position="{{ coordinates.center }}" draggable="true"></marker>
				</ngui-map>
			</span>

			<span *ngIf="streetViewVisible">
				<span *ngIf="mapVisible && showMap">
					<ngui-map>
						<street-view-panorama
							position="{{ coordinates.latitude }}, {{ coordinates.longitude }}"
							addressControl="false"
						>
						</street-view-panorama>
					</ngui-map>
				</span>
			</span>
		</div>
	`,
	styleUrls: ['./map.component.scss'],
})
export class MapComponent extends BaseComponent implements OnInit {
	@Input() address: FullAddress;
	@Input() streetViewVisible: boolean;
	@Input() mapVisible: boolean;
	notAbleToLocate: boolean;
	streetViewControl: boolean = true;
	showMap: boolean = false;
	coordinates: any;
	options: {};
	requestsCount: number = 0;

	constructor(
		injector: Injector,
		private Addresses: AddressesService,
		private el: ElementRef,
		private loadTimeService: LoadTimeService
	) {
		super(injector);
	}

	ngOnInit() {
		this.coordinates = null;
		this.options = {
			addressControl: false,
			linksControl: false,
			zoomControl: true,
		};

		this.setCoordinates();
	}

	async setCoordinates() {
		this.notAbleToLocate = false;
		if (!this.mapVisible && !this.streetViewVisible) {
			return;
		}

		this.coordinates = {};

		if (!this.address.latitude && !this.address.longtitude) {
			const response = await this.Addresses.getGoogleSuggestions(this.address);
			this.coordinates = {
				latitude: response.results[0].geometry.location.lat,
				longitude: response.results[0].geometry.location.lng,
				center: response.results[0].formatted_address,
			};
		} else if (this.address) {
			this.coordinates = {
				latitude: this.address.latitude,
				longitude: this.address.longtitude,
				center: `${this.address.city}, ${this.address.state} ${this.address.zipCode} USA`,
			};
		} else {
			this.coordinates = null;
			this.notAbleToLocate = true;
			return;
		}

		this.notAbleToLocate = false;

		this.showMap = true;
		setTimeout(() => {
			const focusElems = this.el.nativeElement.querySelectorAll('a ,button, iframe');
			forEach(focusElems, (e: Element) => {
				this.Renderer.setAttribute(e, 'tabindex', '-1');
			});
			const googleMapsElems = this.el.nativeElement.querySelectorAll('.google-map');
			let reqId = '';

			reqId = this.loadTimeService.beginTimeMeasure();

			if (googleMapsElems) {
				forEach(googleMapsElems, (item: any) => {
					const divElems = item.querySelectorAll('div');
					forEach(divElems, (e: Element) => {
						this.Renderer.removeAttribute(e, 'tabindex');
					});
				});

				this.loadTimeService.endTimeMeasure(reqId);
				const loadTime = this.loadTimeService.calculateTimeMeasure(reqId);
				if (loadTime.bucket != 'ERROR') {
					this.splunkAnalyticsService.publish('SysEvent', 'GoogleSuggestions', loadTime.loadTime);
				}
			}
		}, 2000);
	}
}
